module.exports = __webpack_public_path__ + "static/reg-large1-764295a17f157855e2e4b69b874f3e98.jpg";